import React, { useEffect, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import HeaderSection from '../../../components/headers/catalogs/HeaderSection';
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import InputForm from '../../../components/Inputs/formInput/InputForm';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import DropdownForm from '../../../components/Inputs/formInput/DropdonwForm';
import Error from '../../../components/errors/Error';
import { createStudentThunk, updateStudentThunk, getStudentThunk, initialStateStudents, deleteRelationThunk } from '../../../store/slices/catalogs/students.slice';
import { getLevelsThunk } from '../../../store/slices/catalogs/levels.slice';
import { getCoursesThunk } from '../../../store/slices/catalogs/courses.slice';
import { getParallelsThunk } from '../../../store/slices/catalogs/parallels.slice';
import { getFatherInfoThunk, hideTooltip } from '../../../store/slices/catalogs/father.slice';
import { fathers } from '../../../resources/optionsList';

const StudentForm = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { student_id } = useParams();
    const { handleSubmit, formState: { errors } } = useForm();
    const { item, message, error } = useSelector(state => state.students);
    const { father, tooltip, loading } = useSelector(state => state.fathers);
    const levelsState = useSelector(state => state.levels);
    const coursesState = useSelector(state => state.courses);
    const parallelsState = useSelector(state => state.parallels);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const [dataFather, setDataFather] = useState([]);
    const [studentData, setStudentData] = useState({
        ciStudent: '',
        firstName: '',
        lastName: '',
        gender: '',
        nationality: '',
        levelId: '',
        parallelId: '',
        courseId: '',
        active: false
    });
    const [currentIndex, setCurrentIndex] = useState(null);
    const [disabledIndices, setDisabledIndices] = useState([]);

    useEffect(() => {
        dispatch(getLevelsThunk());
        dispatch(getCoursesThunk());
        dispatch(getParallelsThunk());
        if (student_id) {
            dispatch(getStudentThunk(student_id));
        }
        return () => {
            dispatch(initialStateStudents());
        };
    }, [dispatch, student_id]);

    useEffect(() => {
        if (Array.isArray(item.parents)) {
            setDataFather(
                item.parents.map(parent => ({
                    id: parent.id,
                    ciParent: parent.parent?.ci_padre,
                    firstName: parent.parent?.nombre,
                    lastName: parent.parent?.apellido,
                    relationship: parent.parent?.parentesco,
                    email: parent.parent?.email,
                    adress: parent.parent?.direccion,
                    phone: parent.parent?.celular,
                    homePhone: parent.parent?.telefono_casa,
                    nationality: parent.parent?.nacionalidad,
                    isLegalRepresentative: parent.parent?.representante_legal
                }))
            );
            if (Object.keys(item).length !== 0) {
                setStudentData({
                    ciStudent: item.ci_estudiante,
                    firstName: item.nombre,
                    lastName: item.apellido,
                    gender: item.genero,
                    nationality: item.nacionalidad,
                    levelId: item.codigo_nivel,
                    parallelId: item.codigo_paralelo,
                    courseId: item.codigo_curso,
                    active: item.active
                });
            }
        }
    }, [item]);

    console.log('studentData', item);

    const onSubmit = (data) => {
        const finalData = { ...studentData, parents: dataFather };
        if (student_id) {
            dispatch(updateStudentThunk(student_id, finalData));
        } else {
            dispatch(createStudentThunk(finalData));
        }
    };

    const handleAddItem = () => {
        setDataFather([...dataFather, {
            ciParent: '',
            firstName: '',
            lastName: '',
            relationship: '',
            email: '',
            adress: '',
            phone: '',
            homePhone: '',
            nationality: '',
            isLegalRepresentative: false
        }]);
    };

    const handleDelete = (index) => {
        setDataFather(dataFather.filter((_, i) => i !== index));
    };

    const handleDeleteRelation = (id) => {
        dispatch(deleteRelationThunk(id));
    };

    const handleStudentChange = useCallback((field, value) => {
        setStudentData(prevData => ({ ...prevData, [field]: value }));
    }, []);

    const handleChange = useCallback((index, field, value) => {
        setDataFather(dataFather.map((item, i) => i === index ? { ...item, [field]: value } : item));
    }, [dataFather]);

    const handleBlur = (index, event) => {
        const ciParent = event.target.value;
        setCurrentIndex(index);
        dispatch(getFatherInfoThunk(ciParent));
    };

    useEffect(() => {
        if (father && currentIndex !== null) {
            setDataFather(prevDataFather =>
                prevDataFather.map((item, i) =>
                    i === currentIndex ? {
                        ...item,
                        firstName: father.nombre,
                        lastName: father.apellido,
                        relationship: father.parentesco,
                        email: father.email,
                        adress: father.direccion,
                        phone: father.celular,
                        homePhone: father.telefono_casa,
                        nationality: father.nacionalidad,
                        isLegalRepresentative: father.representante_legal
                    } : item
                )
            );
            if (!student_id && !disabledIndices.includes(currentIndex)) {
                setDisabledIndices([...disabledIndices, currentIndex]);
            }
            dispatch(hideTooltip());
        } else if (currentIndex !== null && !father) {
            setDataFather(prevDataFather =>
                prevDataFather.map((item, i) =>
                    i === currentIndex ? {
                        ...item,
                        firstName: '',
                        lastName: '',
                        relationship: '',
                        email: '',
                        adress: '',
                        phone: '',
                        homePhone: '',
                        nationality: '',
                        isLegalRepresentative: false
                    } : item
                )
            );
            setDisabledIndices(disabledIndices.filter(index => index !== currentIndex));
        }
    }, [father, currentIndex, dispatch, student_id]);

    useEffect(() => {
        if (message === "Registro creado correctamente" || message === "Registro actualizado correctamente") {
            navigate('/panel/students');
        }
        if (message === "Registro eliminado correctamente") {
            dispatch(getStudentThunk(student_id));
        }
    }, [message, navigate]);

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5">
                    {error && <Error state={error === 'Validation error' ? 'Ya existe un estudiante con este número de cedula' : error} />}
                    {tooltip.visible && <div className="tooltip">{tooltip.message}</div>}
                    <HeaderForm title={student_id ? "Editar informacion" : "Nuevo ingreso"} />
                    <div className='h-[90%]'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <HeaderSection title={"Registro de estudiante"} />
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Cedula")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    value={studentData.ciStudent}
                                    onChange={(event) => handleStudentChange('ciStudent', event.target.value)}
                                    errors={errors.ciStudent && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    spam={true}
                                    label={t("user_name")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    value={studentData.firstName}
                                    onChange={(event) => handleStudentChange('firstName', event.target.value)}
                                    errors={errors.firstName && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    spam={true}
                                    label={t("user_lastName")}
                                    type="text"
                                    input="input"
                                    cols={1}
                                    value={studentData.lastName}
                                    onChange={(event) => handleStudentChange('lastName', event.target.value)}
                                    placeholder={t("user_lastName")}
                                    errors={errors.lastName && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("Genero")}
                                    type="text"
                                    input="input"
                                    cols={1}
                                    value={studentData.gender}
                                    onChange={(event) => handleStudentChange('gender', event.target.value)}
                                    errors={errors.gender && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    spam={true}
                                    label={t("Nacionalidad")}
                                    type="text"
                                    input="input"
                                    cols={1}
                                    value={studentData.nationality}
                                    onChange={(event) => handleStudentChange('nationality', event.target.value)}
                                    errors={errors.nationality && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>

                            <div className='flex gap-2 p-2 mb-2'>
                                <DropdownForm
                                    label={t("Sección")}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    value={studentData.levelId}
                                    onChange={(event) => handleStudentChange('levelId', event.target.value)}
                                    options={levelsState.items}
                                    errors={errors.levelId && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <DropdownForm
                                    label={t("Curso")}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    value={studentData.courseId}
                                    onChange={(event) => handleStudentChange('courseId', event.target.value)}
                                    options={coursesState.items}
                                    errors={errors.courseId && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <DropdownForm
                                    label={t("Paralelo")}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    value={studentData.parallelId}
                                    onChange={(event) => handleStudentChange('parallelId', event.target.value)}
                                    options={parallelsState.items}
                                    errors={errors.parallelId && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    type="checkbox"
                                    label={t("Desactivar para no matricular")}
                                    input="checkbox"
                                    spam={false}
                                    cols={1}
                                    checked={studentData.active}
                                    onChange={(event) => handleStudentChange('active', event.target.checked)}
                                />
                            </div>
                            <HeaderSection title={"Registro de familiar"} />
                            {dataFather.map((item, index) => (
                                <div key={index} className='w-full mb-2 shadow-md shadow-gray-300 bg-gray-300/20 rounded-md py-2 border flex flex-col'>
                                    <div className='flex gap-2 p-2'>
                                        <div className={`flex text-start flex-col w-full cols cols-1`}>
                                            <label className="text-sm flex items-center m-1 font-semibold">
                                                <p>Cedula</p>
                                                <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                className={`input input-sm input-bordered focus:outline-none focus:ring-1 rounded-sm`}
                                                type='text'
                                                value={item.ciParent}
                                                onChange={(event) => handleChange(index, 'ciParent', event.target.value)}
                                                onBlur={(event) => handleBlur(index, event)}
                                            />
                                        </div>
                                        <InputForm
                                            spam={true}
                                            label={t("user_name")}
                                            input="input"
                                            type="text"
                                            cols={1}
                                            value={item.firstName}
                                            onChange={(event) => handleChange(index, 'firstName', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                        <InputForm
                                            spam={true}
                                            label={t("user_lastName")}
                                            type="text"
                                            input="input"
                                            cols={1}
                                            value={item.lastName}
                                            onChange={(event) => handleChange(index, 'lastName', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                    </div>
                                    <div className='flex gap-2 p-2'>
                                        <DropdownForm
                                            label={t("Parentesco")}
                                            input="input"
                                            spam={true}
                                            cols={1}
                                            value={item.relationship}
                                            options={fathers}
                                            onChange={(event) => handleChange(index, 'relationship', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                        <InputForm
                                            spam={true}
                                            label={t("Nacionalidad")}
                                            input="input"
                                            type="text"
                                            cols={1}
                                            value={item.nationality}
                                            onChange={(event) => handleChange(index, 'nationality', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                    </div>
                                    <div className='flex gap-2 p-2'>
                                        <InputForm
                                            spam={true}
                                            label={t("Email")}
                                            input="input"
                                            type="text"
                                            cols={1}
                                            value={item.email}
                                            onChange={(event) => handleChange(index, 'email', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                        <InputForm
                                            spam={true}
                                            label={t("Telefono de casa")}
                                            type="text"
                                            input="input"
                                            cols={1}
                                            value={item.homePhone}
                                            onChange={(event) => handleChange(index, 'homePhone', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                        <InputForm
                                            spam={true}
                                            label={t("Telefono celular")}
                                            type="text"
                                            input="input"
                                            cols={1}
                                            value={item.phone}
                                            onChange={(event) => handleChange(index, 'phone', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                    </div>
                                    <div className='flex gap-2 p-2'>
                                        <InputForm
                                            type="checkbox"
                                            label={t("Habilitado para matricular")}
                                            input="checkbox"
                                            spam={false}
                                            cols={1}
                                            checked={item.isLegalRepresentative}
                                            onChange={(event) => handleChange(index, 'isLegalRepresentative', event.target.checked)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                    </div>
                                    <div className='flex gap-2 p-2'>
                                        <InputForm
                                            spam={true}
                                            label={t("Direccion")}
                                            input="input"
                                            type="text"
                                            cols={1}
                                            value={item.adress}
                                            onChange={(event) => handleChange(index, 'adress', event.target.value)}
                                            disabled={disabledIndices.includes(index)}
                                        />
                                    </div>
                                    {item.id ?
                                        <div className='p-2 justify-end w-full flex'>
                                            <button
                                                type="button"
                                                className='hover:bg-red-300/40 px-3 text-[14px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                                onClick={() => handleDeleteRelation(item.id)}>
                                                <FaTrashAlt />Eliminar
                                            </button>
                                        </div>
                                        :
                                        <div className='p-2 justify-end w-full flex'>
                                            <button
                                                type="button"
                                                className='hover:bg-red-300/40 px-3 text-[14px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                                onClick={() => handleDelete(index)}>
                                                <FaTrashAlt />Eliminar
                                            </button>
                                        </div>
                                    }

                                </div>
                            ))}
                            {dataFather.length < 2 && (
                                <div className='p-2'>
                                    <button
                                        type="button"
                                        className='hover:bg-green-300/40 text-[12px] font-semibold transition-all gap-1 p-1 active:scale-95 rounded-full flex justify-center items-center w-30 h-8'
                                        onClick={handleAddItem}><FaPlus />Agregar familiar</button>
                                </div>
                            )}
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-p-green mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/students`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default StudentForm;
